<template>
  <div class="chocolates-section-component" v-if="chocolates">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cta-text text-center">
            <h2 class="d-none d-lg-block">Chocolates for Every Need</h2>
            <h2 class="d-block d-lg-none">Chocolates <br/> for Every Need</h2>
            <p>
              From baking to snacking, drinking to gifting, we got you covered! <br/> Explore our products to find what you need.
            </p>
          </div>
        </div>
        <div class="col-12 col-lg-4 d-none d-lg-block" v-for="(chocolate, index) in chocolates" :key="index">
          <div class="product-container mt-5">
            <div class="product-image" :style="backgroundImage(chocolate.image)"></div>
            <div class="product-name">
              <strong>{{ chocolate.name }}</strong>
              <div class="mt-2">Php {{ chocolate.price }}</div>
              <div class="rating mt-2">
                <p v-if="chocolate.rating === 0">No rating yet</p>
                <img v-for="(rating, index) in chocolate.rating" :key="index" class="choco-rating" src="../../assets/images/store/choco-rating.png" height="20">
                <img v-show="chocolate.rating > 0" v-for="(rating, index) in (5 - chocolate.rating)" :key="index + 10" class="choco-rating" src="../../assets/images/store/no-choco-rating.png" height="20">
              </div>
            </div>
            <div class="external-link mt-3">
              <a
                :href="`/products/${chocolate.category_slug}`"
                class="btn btn-block btn-dutche-orange"
              >
                <strong>{{ chocolate.category }}</strong>
              </a>
            </div>
          </div>
        </div>
        <div class="col-12 d-block d-lg-none chocolate-slider">
        <VueSlickCarousel v-bind="settings">
          {{ settings }} 
          <div class="slider-item" v-for="(chocolate, index) in chocolates" :key="index">
            <div class="product-container mt-5">
              <div class="product-image" :style="backgroundImage(chocolate.image)"></div>
              <div class="product-name">
                <strong>{{ chocolate.name }}</strong>
                <div class="mt-2">Php {{ chocolate.price }}</div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>  
        </div>
        <div class="col-12 text-center">
          <a href="/store" class="btn btn-dutche">Shop Now</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "Chocolates",
  components: { VueSlickCarousel },
  props: {
    chocolates: Array
  },
  methods: {
    backgroundImage(imageUrl) {
      return { backgroundImage: `url(${imageUrl})` };
    }
  },
  data() {
    return {
      settings: {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 6,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.product-container
  a:visited
    color: $white
    text-decoration: none

  a:hover, a:focus
    color: $dutche-primary-yellow
    text-decoration: none

  .product-name
    min-height: 50px
    height: 120px
    background-color: $dutche-primary-brown
    padding: 1rem
    color: $white

  .product-image
    background-position: center
    background-size: cover
    height: 350px

  .product-image-overlay
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    text-align: center
    padding-top: 50%
    text-transform: uppercase

  .product-image a,
  .product-image a:active,
  .product-image a:visited
    color: $dutche-primary-brown
    text-decoration: none

  .product-image a:hover,
  .product-image a:focus
    color: $dutche-primary-violet
    text-decoration: none

  .btn-dutche-orange
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-orange
    color: $white

.product-container:hover
  .product-name
    background-color: $dutche-primary-yellow

  .product-image-overlay
    background-color: $dutche-quaternary-yellow

.cta-text
  margin-top: 8rem

h2
  font-size: 5rem
  font-family: "Might Could"

.chocolates-section-component
  background-color: $dutche-senary-violet
  padding-bottom: 4rem

.btn-dutche
  text-transform: uppercase
  border-radius: 0.5rem
  background-color: $dutche-primary-violet
  color: $white
  font-weight: bold
  font-size: 1.2em
  text-align: center
  padding: 0.8rem 2rem
  margin-top: 4rem

.chocolate-slider

  .product-container
    padding: 0 2rem

@media (max-width: 767px)
  .cta-text
    margin-top: 6rem !important
    h2
      font-size: 2.2em !important
    p
      font-size: 0.8em

  .product-container
    .product-image
      background-position: center
      background-size: contain
      height: 280px
      background-repeat: no-repeat
      background-color: #fff

@media (max-width: 575px)
  .choco-slider .carousel-caption
    text-align: center
    background-color: #a3361a
    width: 100%
    bottom: 0
    right: 0
    left: 0
    padding: 2rem 0
  .choco-slider .carousel-caption
    h3
      font-size: 1.25rem
      margin-bottom: 1rem 
  .cta-text
    margin-top: 4rem !important
  .cta-text
    h2
      font-size: 3rem
</style>

<style type="text/css">
  .slick-slider .slick-prev {
    left: 10px;
  }
  .slick-slider .slick-next {
    right: 15px;
  }
  .slick-slider .slick-prev:before, .slick-next:before {
    font-size: 30px;
    color: #a3361a;
  }
  @media (max-width: 767px) {
    .slick-slider .slick-prev {
      left: 0px;
    }
    .slick-slider .slick-next {
      right: 10px;
    }
  }
</style>
